import { useEffect, useState } from "react";
import usePopper from "./usePopper";

interface UseMousePopperParams {
    enterDelay?: number
}

const useMousePopper = (params?: UseMousePopperParams) => {

    const popper = usePopper();

    const [anchorElDelayed, setAnchorElDelayed] = useState<HTMLElement | null>(null);

    useEffect(() => {
        if (popper.anchorEl) {
            const timeout = setTimeout(() => {
                setAnchorElDelayed(popper.anchorEl);
            }, params?.enterDelay)
            return () => {
                clearTimeout(timeout);
            }
        }
        else {
            setAnchorElDelayed(null);
        }
    }, [popper.anchorEl]);

    return {
        anchorEl: params?.enterDelay ? anchorElDelayed : popper.anchorEl,
        open: params?.enterDelay ? Boolean(anchorElDelayed) : popper.open,
        handleShow: popper.handleShow,
        handleClose: popper.handleClose
    };
};

export default useMousePopper;